import { Formatter } from '@stamhoofd/utility';
export var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["Pending"] = "Pending";
    PaymentStatus["Failed"] = "Failed";
    PaymentStatus["Succeeded"] = "Succeeded";
    PaymentStatus["Created"] = "Created";
})(PaymentStatus || (PaymentStatus = {}));
export class PaymentStatusHelper {
    static getName(method) {
        switch (method) {
            case PaymentStatus.Pending: return $t(`%mu`);
            case PaymentStatus.Created: return $t(`%mu`);
            case PaymentStatus.Succeeded: return $t(`%mv`);
            case PaymentStatus.Failed: return $t(`%mw`);
        }
    }
    static getNameCapitalized(method) {
        return Formatter.capitalizeFirstLetter(PaymentStatusHelper.getName(method));
    }
}
//# sourceMappingURL=PaymentStatus.js.map